//Site URL
export const SITE_URL = 'https://www.phocafe.co.uk';

//Root/Home Page WP ID
export const HOME_PAGE_ID = 6;

//CMS Endpoints
export const API_URL        = "https://content.phocafe.co.uk"
export const GRAPHQL_API_URL   = API_URL+"/graphql"
export const MODULES_API_URL   = API_URL+"/wp-json/custom/v1/getPostModules"
export const GLOBAL_SETTINGS_API_URL   = API_URL+"/wp-json/custom/v1/getGlobalSettings"
export const ENQUIRY_FORM_API_URL = API_URL+"/wp-json/custom/v1/enquiry-form"
export const NEWSLETTER_FORM_API_URL = API_URL+"/wp-json/custom/v1/newsletter-signup"
//3rd Party APIs
export const POSTCODES_API_URL = "https://api.postcodes.io/postcodes/"
